import React from 'react';
import { Module, ModuleBody, ModuleHeader } from '@wfp/ui';

import { OperationalUpdates } from './OperationalUpdates';


export function RightPanel() {
	return (
		<div style={{width: 300}}>
			<Module>
				<ModuleHeader>Operational updates</ModuleHeader>
				<ModuleBody>
					<OperationalUpdates/>
				</ModuleBody>
			</Module>
		</div>
	);
}